import { createClass as _createClass, classCallCheck as _classCallCheck, defineProperty as _defineProperty, asyncToGenerator as _asyncToGenerator, regeneratorRuntime as _regeneratorRuntime, objectSpread2 as _objectSpread2 } from '../../_virtual/_rollupPluginBabelHelpers.js';
import Poller from './Poller.js';

var defaultPollOptions = {
  interval: 3000,
  timeout: 180000,
  key: null
};
var PollManager = /*#__PURE__*/function () {
  function PollManager() {
    _classCallCheck(this, PollManager);
    _defineProperty(this, "_keyedPolls", {});
    _defineProperty(this, "_unkeyedPolls", []);
  }
  _createClass(PollManager, [{
    key: "poll",
    value: function () {
      var _poll = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(asyncFn, options) {
        var mergedOptions, key, interval, timeout, poller, result;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                mergedOptions = _objectSpread2(_objectSpread2({}, defaultPollOptions), options);
                key = mergedOptions.key, interval = mergedOptions.interval, timeout = mergedOptions.timeout;
                poller = new Poller();
                if (key) {
                  if (Object.prototype.hasOwnProperty.call(this._keyedPolls, key)) {
                    this.cancel(key);
                  }
                  this._keyedPolls[key] = poller;
                } else {
                  this._unkeyedPolls.push(poller);
                }
                _context.prev = 4;
                _context.next = 7;
                return poller.poll(asyncFn, interval, timeout);
              case 7:
                result = _context.sent;
                this._removePoller(key, poller);
                return _context.abrupt("return", result);
              case 12:
                _context.prev = 12;
                _context.t0 = _context["catch"](4);
                this._removePoller(key, poller);
                throw _context.t0;
              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[4, 12]]);
      }));
      function poll(_x, _x2) {
        return _poll.apply(this, arguments);
      }
      return poll;
    }()
  }, {
    key: "cancel",
    value: function cancel(key) {
      if (Object.prototype.hasOwnProperty.call(this._keyedPolls, key)) {
        this._keyedPolls[key].cancel();
        this._removePoller(key);
      }
    }
  }, {
    key: "cancelAll",
    value: function cancelAll() {
      var _this = this;
      Object.keys(this._keyedPolls).forEach(function (key) {
        return _this.cancel(key);
      });
      this._unkeyedPolls.forEach(function (poll) {
        return poll.cancel();
      });
    }
  }, {
    key: "_removePoller",
    value: function _removePoller(key, poller) {
      if (key != null) {
        if (Object.prototype.hasOwnProperty.call(this._keyedPolls, key)) {
          delete this._keyedPolls[key];
        }
      } else {
        this._unkeyedPolls = this._unkeyedPolls.filter(function (unkeyedPoller) {
          return unkeyedPoller !== poller;
        });
      }
    }
  }]);
  return PollManager;
}();
var PollManager$1 = new PollManager();

export { PollManager$1 as default };
